"use strict";
// Copyright (c) 2023-2025, Brandon Lehmann <brandonlehmann@gmail.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = exports.Response = exports.Headers = void 0;
exports.fetch = fetch;
exports.Fetch = fetch;
const cross_fetch_1 = __importStar(require("cross-fetch"));
Object.defineProperty(exports, "Headers", { enumerable: true, get: function () { return cross_fetch_1.Headers; } });
Object.defineProperty(exports, "Request", { enumerable: true, get: function () { return cross_fetch_1.Request; } });
Object.defineProperty(exports, "Response", { enumerable: true, get: function () { return cross_fetch_1.Response; } });
const abort_controller_1 = __importDefault(require("abort-controller"));
const helpers_1 = require("./helpers");
/**
 * Performs a fetch request with the given options
 * @param url
 * @param init
 */
async function fetch(url, init = {}) {
    init = (0, helpers_1.normalizeInit)(init);
    url = url.toString();
    const controller = new abort_controller_1.default();
    let _timeout;
    if (init.timeout) {
        init.signal ??= controller.signal;
        _timeout = setTimeout(() => controller.abort(), init.timeout);
    }
    const response = await (0, cross_fetch_1.default)(url, init);
    if (_timeout) {
        clearTimeout(_timeout);
    }
    return response;
}
(function (fetch) {
    function get(url, init = {}) {
        return fetch(url, { ...init, method: 'GET' });
    }
    fetch.get = get;
    function head(url, init = {}) {
        return fetch(url, { ...init, method: 'HEAD' });
    }
    fetch.head = head;
    function post(url, init = {}) {
        return fetch(url, { ...init, method: 'POST' });
    }
    fetch.post = post;
    function put(url, init = {}) {
        return fetch(url, { ...init, method: 'PUT' });
    }
    fetch.put = put;
    function del(url, init = {}) {
        return fetch(url, { ...init, method: 'DELETE' });
    }
    fetch.del = del;
    function connect(url, init = {}) {
        return fetch(url, { ...init, method: 'CONNECT' });
    }
    fetch.connect = connect;
    function options(url, init = {}) {
        return fetch(url, { ...init, method: 'OPTIONS' });
    }
    fetch.options = options;
    function trace(url, init = {}) {
        return fetch(url, { ...init, method: 'TRACE' });
    }
    fetch.trace = trace;
    function patch(url, init = {}) {
        return fetch(url, { ...init, method: 'PATCH' });
    }
    fetch.patch = patch;
    function propFind(url, init = {}) {
        return fetch(url, { ...init, method: 'PROPFIND' });
    }
    fetch.propFind = propFind;
    function propPatch(url, init = {}) {
        return fetch(url, { ...init, method: 'PROPPATCH' });
    }
    fetch.propPatch = propPatch;
    function mkCol(url, init = {}) {
        return fetch(url, { ...init, method: 'MKCOL' });
    }
    fetch.mkCol = mkCol;
    function copy(url, init = {}) {
        return fetch(url, { ...init, method: 'COPY' });
    }
    fetch.copy = copy;
    function move(url, init = {}) {
        return fetch(url, { ...init, method: 'MOVE' });
    }
    fetch.move = move;
    function lock(url, init = {}) {
        return fetch(url, { ...init, method: 'LOCK' });
    }
    fetch.lock = lock;
    function unlock(url, init = {}) {
        return fetch(url, { ...init, method: 'UNLOCK' });
    }
    fetch.unlock = unlock;
    function mkCalendar(url, init = {}) {
        return fetch(url, { ...init, method: 'MKCALENDAR' });
    }
    fetch.mkCalendar = mkCalendar;
    function report(url, init = {}) {
        return fetch(url, { ...init, method: 'REPORT' });
    }
    fetch.report = report;
    function acl(url, init = {}) {
        return fetch(url, { ...init, method: 'ACL' });
    }
    fetch.acl = acl;
    function search(url, init = {}) {
        return fetch(url, { ...init, method: 'SEARCH' });
    }
    fetch.search = search;
    function query(url, init = {}) {
        return fetch(url, { ...init, method: 'QUERY' });
    }
    fetch.query = query;
    function bind(url, init = {}) {
        return fetch(url, { ...init, method: 'BIND' });
    }
    fetch.bind = bind;
    function unbind(url, init = {}) {
        return fetch(url, { ...init, method: 'UNBIND' });
    }
    fetch.unbind = unbind;
    function rebind(url, init = {}) {
        return fetch(url, { ...init, method: 'REBIND' });
    }
    fetch.rebind = rebind;
})(fetch || (exports.Fetch = exports.fetch = fetch = {}));
exports.default = fetch;
